import React from "react";
import { Alert } from '@sainsburys-tech/fable';
import { AlertCircleFilled } from '@sainsburys-tech/icons'

const BannerListItem = ({ children, isOpen, status, error, warning, ...rest }) => (
  <div className="fable:pb-4">
    <Alert
      {...rest}
      leadingIcon={<AlertCircleFilled />}
      isOpen={isOpen !== false}
      status={status || (error ? "error" : warning ? "warning" : "error")}
      message={children}
    />
  </div>
);

export default BannerListItem;
